import dayjs from "dayjs"; 
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import { motion } from "framer-motion";
import Popover from "@mui/material/Popover";
import Select from "react-select";
import IRMenu from "./IRMenu";
import KeyManagerialPersonsModal from "./KeyManagerialPersonsModal";
import CommonDatePicker from "../../../myfin_v2/elements/CommonDatePicker";
import DeletePopup from "../../../myfin_v2/elements/DeletePopup";
import SuccessPopup from "../../../myfin_v2/elements/SuccessPopup";
import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";
import { getKeyInvestmentPersons, getLinkedCompanies, deleteKeyManagerialPerson, getInvestmentRegisterForms, updateKeyManagerialPerson } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import swal from "sweetalert";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as LeftArrowIcon } from "../../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as DotIcon } from "../../../myfin_v2/assets/icons/dot.svg";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as PlusPrimaryIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as MenuDotsIcon } from "../../../myfin_v2/assets/icons/menu_dot.svg";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/edit.svg";
import { ReactComponent as DownGreyIcon } from "../../../myfin_v2/assets/icons/down_grey.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close_grey.svg";

const customSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#ffffff',
        borderColor: '#c2e6d1',
        boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
        borderRadius: '6px',
        '&:hover': {
            borderColor: '#c2e6d1',
        },
        minHeight: '37px',
        height: '37px',
        borderWidth: '1px',
        cursor: 'text',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0 8px',
        display: 'flex',
        alignItems: 'center',
    }),
    input: (provided) => ({
        ...provided,
        color: '#111',
        margin: 0,
        padding: 0,
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        fontSize: '14px',
        margin: 0,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#111',
        fontSize: '14px',
        margin: 0,
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#c2e6d1',
        padding: '4px',
        ':hover': {
            color: '#4f665f',
        },
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#ffffff',
        border: '1px solid #c2e6d1',
        borderRadius: '6px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        marginTop: '6px',
        zIndex: 9999,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        borderRadius: '6px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: (state.isSelected || state.isFocused) ? '#f4faf5' : 'transparent',
        color: '#111',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '14px',
        borderRadius: '4px',
        marginBottom: '2px',
        fontWeight: (state.isSelected || state.isFocused) ? 600 : 400,
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};

const KeyManagerialPersons = () => {

    const { irId } = useParams();
    const history = useHistory();

    const [anchorEl, setAnchorEl] = useState(null);
    const [openPopoverId, setOpenPopoverId] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [keyPersons, setKeyPersons] = useState([]);
    const [editableRows, setEditableRows] = useState([]);
    const [showHeaderSearch, setShowHeaderSearch] = useState(false);
    const [headerSearchValue, setHeaderSearchValue] = useState("");
    const [showSearch, setShowSearch] = useState(false);
    const [companySearch, setCompanySearch] = useState("");
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [deletePopup, setDeletePopup] = useState({ isOpen: false, id: null });
    const [successPopup, setSuccessPopup] = useState({ isOpen: false, message: "" });
    const [registerName, setRegisterName] = useState("");

    // ── Replaced static companyList with API-driven state ─────────────────────
    const [companyList, setCompanyList] = useState([]);

    // ── Fetch linked companies from API ───────────────────────────────────────
    useEffect(() => {
        if (!irId) return;
        getLinkedCompanies(irId)
            .then((res) => {
                // API: { success: true, companies: [{ _id, company_name, company_code }] }
                const companies = res.data?.companies || [];
                setCompanyList(companies);
            })
            .catch((err) => {
                console.error("Failed to fetch linked companies:", err);
            });

        getInvestmentRegisterForms(irId)
            .then(res => setRegisterName(res.data?.investmentRegister?.name || "Investment Register"))
            .catch(err => console.error(err));
    }, [irId]);

    useEffect(() => {

    }, [])

    const filteredCompanies = companyList.filter((c) =>
        c.company_name.toLowerCase().includes(companySearch.toLowerCase())
    );

    const open = Boolean(anchorEl);

    const handleAdd = () => {
        setSelectedData(null);
        setModalType("add");
        setModalOpen(true);
    };

    const handleMenuClick = (event, id) => {
        setAnchorEl(event.currentTarget);
        setOpenPopoverId(id);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpenPopoverId(null);
    };

    const handleEdit = (item) => {
        setSelectedData(item);
        setModalType("edit");
        setModalOpen(true);
        handleClose();
    };

  const handleDeleteClick = (id) => {
      setDeletePopup({ isOpen: true, id });
      handleClose();
  };

  const handleConfirmDelete = async () => {
      const id = deletePopup.id;
      setDeletePopup({ isOpen: false, id: null });
      try {
          const response = await deleteKeyManagerialPerson(irId, id);
          if (response.status === 200) {
              setSuccessPopup({ isOpen: true, message: "Record deleted successfully." });
              fetchKeyManagerialPersons();
          }
      } catch (error) {
          console.error("Failed to delete record:", error);
          swal("Error", "Failed to delete record", "error");
      }
  };

  const handleSave = async () => {
      try {
          const promises = editableRows.map((row) => {
              const original = keyPersons.find(r => r._id === row._id);
              if (
                  original &&
                  (original.name !== row.name ||
                   original.designation !== row.designation ||
                   original.dateOfAppointment !== row.dateOfAppointment ||
                   original.dateOfResignation !== row.dateOfResignation)
              ) {
                  const payload = {
                      companyID: selectedCompany._id,
                      name: row.name,
                      designation: row.designation,
                      dateOfAppointment: row.dateOfAppointment ? dayjs(row.dateOfAppointment).format("DD-MM-YYYY") : "",
                      dateOfResignation: row.dateOfResignation ? dayjs(row.dateOfResignation).format("DD-MM-YYYY") : "",
                  };
                  return updateKeyManagerialPerson(irId, row._id, payload);
              }
              return null;
          }).filter(Boolean);

          if (promises.length > 0) {
              await Promise.all(promises);
              setSuccessPopup({ isOpen: true, message: "Key managerial persons updated successfully" });
              fetchKeyManagerialPersons();
          } else {
              setSuccessPopup({ isOpen: true, message: "No changes detected" });
          }
          setIsEditing(false);
      } catch (error) {
          console.error("Failed to update key managerial persons:", error);
          swal("Error", error?.response?.data?.error || error?.response?.data?.message || "Failed to update key managerial persons", "error");
      }
  };

    const handleModalClose = () => {
        setModalOpen(false);
        setSelectedData(null);
        setModalType(null);
    };

    const handleRowChange = (id, field, value) => {
        setEditableRows((prev) =>
            prev.map((row) =>
                row._id === id ? { ...row, [field]: value } : row
            )
        );
    };

    const nameOptions = keyPersons.map((p) => p.name);
    const designationOptions = keyPersons.map((p) => p.designation);

    const fetchKeyManagerialPersons = async () => {
        try {
            const res = await getKeyInvestmentPersons(irId, selectedCompany?._id);
            if (res.data.success) {
                const persons = res.data.keyManagerialPersons || [];
                setKeyPersons(persons);
                setEditableRows(persons);
            }
        } catch (error) {
            console.log("Error fetching Key Managerial Persons:", error);
        }
    };

    useEffect(() => {
        const closeSearch = (e) => {
            if (!e.target.closest(`.${investmentRegisterCss.companyPanelHeader}`)) {
                setShowSearch(false);
            }
        };
        document.addEventListener("click", closeSearch);
        return () => document.removeEventListener("click", closeSearch);
    }, []);

    useEffect(() => {
        if (selectedCompany) fetchKeyManagerialPersons();
    }, [selectedCompany?._id]);

    useEffect(() => {
        if (filteredCompanies.length > 0 && !selectedCompany) {
            setSelectedCompany(filteredCompanies[0]);
        }
    }, [filteredCompanies]);

    const displayRows = editableRows.filter((item) => {
        if (!headerSearchValue) return true;
        const search = headerSearchValue.toLowerCase();
        const formattedAppointment = item.dateOfAppointment ? dayjs(item.dateOfAppointment).format("DD-MMM-YYYY").toLowerCase() : "";
        const formattedResignation = item.dateOfResignation ? dayjs(item.dateOfResignation).format("DD-MMM-YYYY").toLowerCase() : "";
        return (
            (item.name && item.name.toLowerCase().includes(search)) ||
            (item.designation && item.designation.toLowerCase().includes(search)) ||
            formattedAppointment.includes(search) ||
            formattedResignation.includes(search)
        );
    });

    return (
        <>
            <div className={`d-flex ${commoncss.pageContent}`}>
                <IRMenu
                    activeTab={"Key Managerial Persons"}
                    registerID={irId}
                />
                <motion.div
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 200, opacity: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className={investmentRegisterCss.irLayout}
                >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div className={investmentRegisterCss.iDHeader} style={{ padding: "10px 0px 10px 0px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px" }}>
                                <Link to={`/detailsIR/${irId}`} style={{ textDecoration: "none", display: "flex", alignItems: "center" }}>
                                    <LeftArrowIcon height={12} style={{ marginBottom: "2px", marginRight: "10px" }} />
                                    <span style={{ color: "#4D6D64", fontWeight: "500" }}>Investments</span>
                                </Link>
                                <DotIcon style={{ margin: "0 4px" }} />
                                <Link to={`/detailsIR/${irId}`} style={{ textDecoration: "none", display: "flex", alignItems: "center" }}>
                                    <span style={{ color: "#4D6D64", fontWeight: "500" }}>{registerName}</span>
                                </Link>
                                <DotIcon style={{ margin: "0 4px" }} />
                                <span style={{ color: "#111", fontWeight: "600" }}>Key Managerial Persons</span>
                            </div>
                        </div>

                        <div className={investmentRegisterCss.iRHeader}>
                            {showHeaderSearch ? (
                                <div className={investmentRegisterCss.headerSearchBar}>
                                    <SearchIcon className={investmentRegisterCss.headerSearchBarIcon} />
                                    <input
                                        autoFocus
                                        type="text"
                                        className={investmentRegisterCss.headerSearchInput}
                                        placeholder="Type something..."
                                        value={headerSearchValue}
                                        onChange={(e) => setHeaderSearchValue(e.target.value)}
                                    />
                                    <CloseIcon
                                        className={investmentRegisterCss.headerSearchClose}
                                        onClick={() => {
                                            setShowHeaderSearch(false);
                                            setHeaderSearchValue("");
                                        }}
                                    />
                                </div>
                            ) : (
                                <SearchIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowHeaderSearch(true)}
                                />
                            )}
                            <FilterIcon style={{ cursor: "pointer" }} />
                        </div>
                    </div>

                    <div className={investmentRegisterCss.shareCapitalLayout}>

                        <div className={investmentRegisterCss.companyPanel}>
                            <div className={investmentRegisterCss.companyPanelHeader}>
                                <span className={investmentRegisterCss.companyPanelTitle}>Select Company</span>
                                <span className={investmentRegisterCss.companyPanelSearchIcon}>
                                    <SearchIcon onClick={() => setShowSearch((prev) => !prev)} />
                                </span>
                            </div>

                            {showSearch && (
                                <div className={investmentRegisterCss.companySearchInputWrapper}>
                                    <input
                                        type="text"
                                        className={investmentRegisterCss.companySearchInput}
                                        placeholder="Search company..."
                                        value={companySearch}
                                        onChange={(e) => setCompanySearch(e.target.value)}
                                        autoFocus
                                    />
                                </div>
                            )}

                             <ul className={investmentRegisterCss.companyList}>
                                {filteredCompanies.map((company) => (
                                    <li
                                        key={company._id}
                                        className={`${investmentRegisterCss.companyListItem} ${
                                            selectedCompany?._id === company._id
                                                ? investmentRegisterCss.companyListItemActive
                                                : ""
                                        }`}
                                        onClick={() => setSelectedCompany(company)}
                                        data-tooltip={company.company_name}
                                        title={company.company_name}
                                    >
                              
                                        {company.company_name}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className={investmentRegisterCss.tableLayout}>
                            <div className={investmentRegisterCss.tableConatiner}>
                                <div className={investmentRegisterCss.tableTitle}>
                                    <span>Key Managerial Persons</span>

                                    {!isEditing ? (
                                        <span className="d-flex gap-1">
                                            <Button
                                                btnColor={buttoncss.greyBg}
                                                icon={<EditIcon />}
                                                class_={investmentRegisterCss.editBtn}
                                                onClick={() => setIsEditing(true)}
                                            />
                                            <Button
                                                btnColor={buttoncss.greyBg}
                                                icon={<PlusPrimaryIcon />}
                                                class_={investmentRegisterCss.addBtnRow}
                                                onClick={handleAdd}
                                            />
                                        </span>
                                    ) : (
                                        <div className={investmentRegisterCss.saveCancelWrap}>
                                            <button
                                                className={investmentRegisterCss.cancelBtn}
                                                onClick={() => {
                                                    setIsEditing(false);
                                                    setEditableRows([...keyPersons]);
                                                }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className={investmentRegisterCss.saveBtn}
                                                onClick={handleSave}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "left", paddingLeft: "20px" }}>Name</th>
                                            <th style={{ textAlign: "left" }}>Designation</th>
                                            <th>Date of appointment</th>
                                            <th>Date of resignation</th>
                                            <th style={{ textAlign: "right", paddingRight: "20px" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {displayRows.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center", padding: "20px", color: "#b3c0bd" }}>No key managerial persons data</td>
                                            </tr>
                                        ) : (
                                            displayRows.map((item) => (
                                                <tr key={item._id}>
                                                <td style={{ textAlign: "left", paddingLeft: "20px" }}>
                                                    {isEditing ? (
                                                        <div style={{ width: "220px", minWidth: "150px" }}>
                                                            <Select
                                                                options={nameOptions.map(opt => ({ label: opt, value: opt }))}
                                                                value={item.name ? { label: item.name, value: item.name } : null}
                                                                onChange={(selected) => handleRowChange(item._id, "name", selected.value)}
                                                                styles={customSelectStyles}
                                                                placeholder="Select name"
                                                                isSearchable={true}
                                                                menuPortalTarget={document.body}
                                                            />
                                                        </div>
                                                    ) : (item.name)}
                                                </td>

                                                <td style={{ textAlign: "left" }}>
                                                    {isEditing ? (
                                                        <div style={{ width: "220px", minWidth: "150px" }}>
                                                            <Select
                                                                options={designationOptions.map(opt => ({ label: opt, value: opt }))}
                                                                value={item.designation ? { label: item.designation, value: item.designation } : null}
                                                                onChange={(selected) => handleRowChange(item._id, "designation", selected.value)}
                                                                styles={customSelectStyles}
                                                                placeholder="Select designation"
                                                                isSearchable={true}
                                                                menuPortalTarget={document.body}
                                                            />
                                                        </div>
                                                    ) : (item.designation)}
                                                </td>

                                                <td>
                                                    {isEditing ? (
                                                        <CommonDatePicker
                                                            value={item.dateOfAppointment ? dayjs(item.dateOfAppointment).format("YYYY-MM-DD") : ""}
                                                            onChange={(val) => handleRowChange(item._id, "dateOfAppointment", val)}
                                                            containerClass=""
                                                            containerStyle={{ backgroundColor: "#f4faf5", border: "1px solid #c2e6d1", borderRadius: "6px", height: "37px", padding: "0 10px", boxShadow: "none", display: "flex", alignItems: "center", justifyContent: "space-between", width: "130px" }}
                                                            inputStyle={{ backgroundColor: "transparent", color: "#4d6d64", fontSize: "14px", height: "100%", width: "100%", border: "none", outline: "none", padding: 0 }}
                                                        />
                                                    ) : item.dateOfAppointment ? (
                                                        dayjs(item.dateOfAppointment).format("DD-MMM-YYYY")
                                                    ) : ("-")}
                                                </td>

                                                <td>
                                                    {isEditing ? (
                                                        <CommonDatePicker
                                                            value={item.dateOfResignation ? dayjs(item.dateOfResignation).format("YYYY-MM-DD") : ""}
                                                            onChange={(val) => handleRowChange(item._id, "dateOfResignation", val)}
                                                            containerClass=""
                                                            containerStyle={{ backgroundColor: "#f4faf5", border: "1px solid #c2e6d1", borderRadius: "6px", height: "37px", padding: "0 10px", boxShadow: "none", display: "flex", alignItems: "center", justifyContent: "space-between", width: "130px" }}
                                                            inputStyle={{ backgroundColor: "transparent", color: "#4d6d64", fontSize: "14px", height: "100%", width: "100%", border: "none", outline: "none", padding: 0 }}
                                                        />
                                                    ) : item.dateOfResignation ? (
                                                        dayjs(item.dateOfResignation).format("DD-MMM-YYYY")
                                                    ) : ("-")}
                                                </td>

                                                <td style={{ textAlign: "right", paddingRight: "20px" }}>
                                                    <MenuDotsIcon
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => handleMenuClick(e, item._id)}
                                                    />
                                                    <Popover
                                                        open={open && openPopoverId === item._id}
                                                        anchorEl={anchorEl}
                                                        onClose={handleClose}
                                                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                    >
                                                        <div className={investmentRegisterCss.irOptions} style={{ width: "160px" }}>
                                                            <span style={{ borderBottom: "1px solid #EAEEED" }} onClick={() => handleEdit(item)}>Edit</span>
                                                            <span onClick={() => handleDeleteClick(item._id)}>Delete</span>
                                                        </div>
                                                    </Popover>
                                                </td>
                                            </tr>
                                         )))
                                         
                                         }
                                     </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </motion.div>
            </div>

            {modalOpen && (
                <KeyManagerialPersonsModal
                    handleClose={handleModalClose}
                    data={selectedData}
                    type={modalType}
                    investmentID={irId}
                    refreshData={fetchKeyManagerialPersons}
                    companyId={selectedCompany._id}
                    onSuccess={(msg) => setSuccessPopup({ isOpen: true, message: msg || "Record saved successfully" })}
                />
            )}

            <DeletePopup
                isOpen={deletePopup.isOpen}
                onConfirm={handleConfirmDelete}
                onCancel={() => setDeletePopup({ isOpen: false, id: null })}
            />
            
            <SuccessPopup
                isOpen={successPopup.isOpen}
                message={successPopup.message}
                onClose={() => setSuccessPopup({ isOpen: false, message: "" })}
            />
        </>
    );
};

export default KeyManagerialPersons;